import {goto} from "./organization.goto";

export * from "./OrganizationRoutes";

export const organizationRoutes = {
    goto: goto,
};
